import React, { useState } from "react";

export default function Header({ scrollToSection, activeSection }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (section) => {
    scrollToSection(section);
    setMenuOpen(false); // zamknij menu po kliknięciu
  };

  return (
    <header className="header">
      <div className="header-inner">
        {/* LOGO */}
        <div className="logo" onClick={() => handleNavClick("hero")}>
          <img src="/images/Frame 60.png" alt="MM Easy Access logo" />
        </div>

        {/* Desktop NAV */}
        <nav className="nav desktop-nav">
          <ul>
            <li
              className={activeSection === "hero" ? "active" : ""}
              onClick={() => handleNavClick("hero")}
            >
              STRONA GŁÓWNA
            </li>
            <li
              className={activeSection === "about" ? "active" : ""}
              onClick={() => handleNavClick("about")}
            >
              O FIRMIE
            </li>
            <li
              className={activeSection === "services" ? "active" : ""}
              onClick={() => handleNavClick("services")}
            >
              USŁUGI
            </li>
            <li
              className={activeSection === "contact" ? "active" : ""}
              onClick={() => handleNavClick("contact")}
            >
              KONTAKT
            </li>
          </ul>
        </nav>

        {/* CTA i HAMBURGER */}
        <div className="header-right">
          <button className="cta" onClick={() => handleNavClick("contact")}>
            ZAMÓW SERWIS
          </button>

          <div
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile MENU - wysuwane z LEWEJ */}
      <div className={`mobile-menu left ${menuOpen ? "show" : ""}`}>
        <ul>
          <li onClick={() => handleNavClick("hero")}>Strona główna</li>
          <li onClick={() => handleNavClick("about")}>O firmie</li>
          <li onClick={() => handleNavClick("services")}>Usługi</li>
          <li onClick={() => handleNavClick("contact")}>Kontakt</li>
        </ul>
      </div>
    </header>
  );
}
